import cfg from '@/config'

export default {
    namespaced: true,
    state: {
        type: localStorage.getItem('publication') || 'itweb',
        apiMode: localStorage.getItem('apiMode') || 'production'
    },
    mutations: {
        setPublication(state, publication) {
            localStorage.setItem('publication', publication);
            state.type = publication;
        },
        setApiMode(state, mode) {
            localStorage.setItem('apiMode', mode);
            state.apiMode = mode;
        }
    },
    getters: {
        isTestMode(state) {
            return state.apiMode === 'test';
        },
        activeApiUrl(state) {
            return state.apiMode === 'test' ? cfg.STAGE_API_URL : cfg.URL;
        },
        websiteUrlFor: () => (type) => {
            switch (type) {
                case 'africa':
                    return cfg.AFRICA_SITE_URL;
                case 'mag':
                    return cfg.MG_SITE_URL;
                case 'brainstorm':
                    return cfg.BRAINSTORM_SITE_URL;
                case 'itweb':
                default:
                    return cfg.SITE_URL;
            }
        },
        activeWebsiteUrl(state, getters) {
            const isTest = state.apiMode === 'test';

            if (isTest && !['africa', 'mag', 'brainstorm'].includes(state.type)) {
                return cfg.STAGE_SITE_URL;
            }
            return getters.websiteUrlFor(state.type);
        }
    }
}
